module.exports = __webpack_public_path__ + "static/media/pii-vehicle.b9a677d4.svg";